import React from "react";
import DisplayArtistData from "../Components/DisplayArtistData";

export const ArtistPage: React.FC = (): React.ReactElement => {
	return <DisplayArtistData></DisplayArtistData>;
};
